import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { BroadcastView, BroadcastViewStore } from 'pages/broadcasts/ui/BroadcastView'

export const CreateBroadcast = () => {
  const entities = useEntitiesContext()
  const [searchParams] = useSearchParams()
  const openAdvanced = searchParams.get('openAdvanced') === 'true'

  const [store] = useState(() => new BroadcastViewStore(entities, undefined, false, openAdvanced))
  return <BroadcastView store={store} />
}
